import { A, CONTACT_EMAIL, H2, LegalLayout, OPERATOR, P, REGISTERED_ADDRESS } from './shared';

// Public, unauthenticated route (see App.tsx) - same content as
// landing/templates.mjs's renderDPA(), ported to this app's components.
// Static for now; a click-to-accept flow waits for a real checkout.
export function DpaScreen() {
  return (
    <LegalLayout title="Data Processing Addendum">
      <P>
        This Data Processing Addendum ("DPA") supplements the <A to="/terms">Terms of Service</A> between you
        ("Customer") and {OPERATOR} ("zmist") and applies where zmist processes personal data on Customer's behalf
        under Regulation (EU) 2016/679 ("GDPR"). If you need a countersigned copy, email {CONTACT_EMAIL}.
      </P>

      <H2>1. Roles</H2>
      <P>
        For personal data Customer or its users submit to the Service, Customer is the controller and zmist is the
        processor. zmist processes that data only on Customer's documented instructions, which the Terms and
        Customer's use of the Service constitute.
      </P>

      <H2>2. Subject matter and duration</H2>
      <P>
        Subject matter: provision of the Service described in the Terms. Duration: for as long as Customer has an
        account, plus the deletion periods described in the <A to="/privacy">Privacy Policy</A>.
      </P>

      <H2>3. Nature and purpose of processing</H2>
      <P>
        Storing, relaying, and displaying channel messages, schemas, reports, and account/profile data so the
        Service functions; sending transactional email; securing the Service.
      </P>

      <H2>4. Categories of data and data subjects</H2>
      <P>
        Data subjects: Customer's authorised users and anyone whose information they choose to send into a channel.
        Categories: account identifiers (email, nickname), profile details the user provides, and the content and
        metadata of messages, signals, schemas, and reports.
      </P>

      <H2>5. Confidentiality</H2>
      <P>zmist ensures that people authorised to process the personal data are bound by an obligation of confidentiality.</P>

      <H2>6. Security</H2>
      <P>
        zmist maintains technical and organisational measures appropriate to the risk, including encryption of data
        in transit, hashed credentials, access controls, session revocation on sign-out, redaction of credentials
        and personal data from server logs, and hosting within the European Union.
      </P>

      <H2>7. Sub-processors</H2>
      <P>
        Customer authorises zmist to engage the sub-processors listed at <A to="/subprocessors">zmist.co/subprocessors</A>.
        zmist imposes data-protection obligations on each sub-processor no less protective than those in this DPA
        and remains liable for their performance. zmist will update that page before adding a sub-processor;
        Customer may object on reasonable data-protection grounds by emailing {CONTACT_EMAIL}.
      </P>

      <H2>8. Data subject rights</H2>
      <P>
        The Service provides self-serve export and deletion tools that let Customer respond to access, portability,
        and erasure requests directly. zmist will additionally assist Customer, taking into account the nature of
        processing, in responding to data-subject requests it cannot fulfil through those tools.
      </P>

      <H2>9. Personal data breach</H2>
      <P>
        zmist notifies Customer without undue delay after becoming aware of a personal data breach affecting
        Customer's data, with the information Customer reasonably needs to meet its own notification obligations.
      </P>

      <H2>10. International transfers</H2>
      <P>
        Where a sub-processor processes personal data outside the EEA, the transfer is governed by the EU Standard
        Contractual Clauses or another valid transfer mechanism.
      </P>

      <H2>11. Deletion and return</H2>
      <P>
        On termination, or on Customer request, zmist deletes Customer's personal data in line with the{' '}
        <A to="/privacy">Privacy Policy</A>'s retention and deletion sections, except where retention is required by
        law.
      </P>

      <H2>12. Audits</H2>
      <P>
        zmist makes available the information necessary to demonstrate compliance with this DPA and contributes to
        audits conducted by Customer or an auditor it mandates, subject to reasonable confidentiality and frequency
        limits.
      </P>

      <H2>13. Contact</H2>
      <P>
        {CONTACT_EMAIL}
        {REGISTERED_ADDRESS ? <> · {REGISTERED_ADDRESS}</> : null}
      </P>
    </LegalLayout>
  );
}
